import { render, staticRenderFns } from "./BonusTable.vue?vue&type=template&id=53bee56a&scoped=true"
import script from "./BonusTable.vue?vue&type=script&lang=js"
export * from "./BonusTable.vue?vue&type=script&lang=js"
import style0 from "./BonusTable.vue?vue&type=style&index=0&id=53bee56a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bee56a",
  null
  
)

export default component.exports